import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ListadoInscripciones = ({ formulario_id, turnos }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
const [search, setSearch] = useState("");
const [sedeFiltro, setSedeFiltro] = useState("");
const [fechaFiltro, setFechaFiltro] = useState("");
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });
const sedes = useMemo(() => {
  const unique = new Set(data.map((d) => d.departamento || "Sin dato"));
  return Array.from(unique);
}, [data]);
const filteredData = useMemo(() => {
  return data.filter((item) => {
    const persona = item.Persona || {};

    const texto = `${persona.dni} ${persona.nombre} ${persona.apellido} ${persona.email}`.toLowerCase();

    const coincideBusqueda = texto.includes(search.toLowerCase());

    const coincideSede = sedeFiltro
      ? (item.departamento || "Sin dato") === sedeFiltro
      : true;

    const turno = item.Persona?.Turnos?.[0]?.turno || "";

    const coincideFecha = fechaFiltro
      ? turno.startsWith(fechaFiltro)
      : true;

    return coincideBusqueda && coincideSede && coincideFecha;
  });
}, [data, search, sedeFiltro, fechaFiltro]);
  const formatearFecha = (fecha) => {
    const [anio, mes, dia] = fecha.split("-");
    return dia + "/" + mes + "/" + anio;
  };

  const styles = {
    container: {
      padding: "20px",
      backgroundColor: "#f4f6f7",
      borderRadius: "10px",
      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    },
    title: {
      textAlign: "center",
      marginBottom: "15px",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      backgroundColor: "#fff",
    },
    row: {
      transition: "0.2s",
    },
    th: {
      cursor: "pointer",
      padding: "10px",
      background: "#ecf0f1",
    },
    td: {
      padding: "8px",
      textAlign: "center",
    },
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      const url = `https://wwwa.isepsantafe.net.ar/expedientes/ingresos/listadoInscripcionesEnviadas?formulario_id=${formulario_id.id}${
        turnos ? "&turnos=true" : ""
      }`;

      const res = await axios.post(url);
     
      
      setData(res.data);
    } catch (err) {
      console.error(err);
      setError("Error al cargar datos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (formulario_id) {
      fetchData();
    }
  }, [formulario_id, turnos]);

  const sortedData = useMemo(() => {
    if (!sortConfig.key) return filteredData;

    return [...data].sort((a, b) => {
      let aValue;
      let bValue;

      switch (sortConfig.key) {
        case "dni":
          aValue = a.Persona?.dni || "";
          bValue = b.Persona?.dni || "";
          break;
        case "nombre":
          aValue = a.Persona?.nombre || "";
          bValue = b.Persona?.nombre || "";
          break;
        case "apellido":
          aValue = a.Persona?.apellido || "";
          bValue = b.Persona?.apellido || "";
          break;
        case "genero":
          aValue = a.Persona?.genero || "";
          bValue = b.Persona?.genero || "";
          break;
        case "turno":
          aValue = a.Persona?.Turnos?.[0]?.turno || "";
          bValue = b.Persona?.Turnos?.[0]?.turno || "";
          break;
        case "sede":
          aValue = a.departamento || "";
          bValue = b.departamento || "";
          break;
        default:
          return 0;
      }

      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
}, [filteredData, sortConfig]);

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction:
        prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const getArrow = (key) => {
    if (sortConfig.key !== key) return "";
    return sortConfig.direction === "asc" ? " 🔼" : " 🔽";
  };

  const exportToExcel = () => {
    const exportData = sortedData.map((item, index) => ({
      "#": index + 1,
      DNI: item.Persona?.dni,
      Nombre: item.Persona?.nombre,
      Apellido: item.Persona?.apellido,
      Email: item.Persona?.email,
      Genero: item.Persona?.genero,
      Sede: item.departamento || "Sin dato",
      Turno: turnos
        ? item.Persona?.Turnos?.[0]?.turno
          ? formatearFecha(item.Persona.Turnos[0].turno)
          : "Sin turno"
        : "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Inscripciones");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(file, `inscripciones_${formulario_id.nombre}.xlsx`);
  };

  if (loading) return <p style={{ textAlign: "center" }}>Cargando...</p>;
  if (error)
    return <p style={{ color: "red", textAlign: "center" }}>{error}</p>;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Listado de Inscripciones</h2>
      <h4 style={{ textAlign: "center" }}>
        "{formulario_id.nombre}"
      </h4>

      <div style={{ textAlign: "right", marginBottom: "10px" }}>
        <button onClick={exportToExcel}>Descargar Excel</button>
      </div>
<div style={{ display: "flex", gap: "10px", marginBottom: "15px", flexWrap: "wrap" }}>
  
  {/* 🔎 BUSCADOR */}
  <input
    type="text"
    placeholder="Buscar por DNI, nombre, apellido o email"
    value={search}
    onChange={(e) => setSearch(e.target.value)}
    style={{ padding: "8px", flex: 1 }}
  />

  {/* 🎯 FILTRO SEDE */}
  <select
    value={sedeFiltro}
    onChange={(e) => setSedeFiltro(e.target.value)}
    style={{ padding: "8px" }}
  >
    <option value="">Todas las sedes</option>
    {sedes.map((sede, i) => (
      <option key={i} value={sede}>
        {sede}
      </option>
    ))}
  </select>

  {/* 📅 FILTRO FECHA */}
  <label htmlFor="">Turnos</label>
  {turnos && (
    <input
      type="date"
      value={fechaFiltro}
      onChange={(e) => setFechaFiltro(e.target.value)}
      style={{ padding: "8px" }}
    />
  )}

  {/* ❌ LIMPIAR */}
  <button
    onClick={() => {
      setSearch("");
      setSedeFiltro("");
      setFechaFiltro("");
    }}
  >
    Limpiar
  </button>

</div>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>#</th>
            <th style={styles.th} onClick={() => handleSort("dni")}>
              DNI {getArrow("dni")}
            </th>
            <th style={styles.th} onClick={() => handleSort("nombre")}>
              Nombre {getArrow("nombre")}
            </th>
            <th style={styles.th} onClick={() => handleSort("apellido")}>
              Apellido {getArrow("apellido")}
            </th>
            <th style={styles.th}>Email</th>
            <th style={styles.th} onClick={() => handleSort("genero")}>
              Género {getArrow("genero")}
            </th>

            {/* 🔥 NUEVA COLUMNA */}
            <th style={styles.th} onClick={() => handleSort("sede")}>
              Sede elegida {getArrow("sede")}
            </th>

            {turnos && (
              <th style={styles.th} onClick={() => handleSort("turno")}>
                Turno {getArrow("turno")}
              </th>
            )}
          </tr>
        </thead>

        <tbody>
          {sortedData.map((item, index) => {
            const turnoFecha =
              item.Persona?.Turnos?.[0]?.turno || null;

            return (
              <tr key={index} style={styles.row}>
                <td style={styles.td}>{index + 1}</td>

                <td
                  style={{
                    ...styles.td,
                    cursor: "pointer",
                    color: "#2e86c1",
                  }}
                  onClick={() =>
                    navigator.clipboard.writeText(item.Persona?.dni)
                  }
                >
                  {item.Persona?.dni}
                </td>

                <td style={styles.td}>{item.Persona?.nombre}</td>
                <td style={styles.td}>{item.Persona?.apellido}</td>
                <td style={styles.td}>{item.Persona?.email}</td>
                <td style={styles.td}>{item.Persona?.genero}</td>

                {/* 🔥 SEDE */}
                <td style={styles.td}>
                  {item.departamento || "Sin dato"}
                </td>

                {turnos && (
                  <td style={styles.td}>
                    {turnoFecha
                      ? formatearFecha(turnoFecha)
                      : "Sin turno"}
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>

      {data.length === 0 && (
        <p style={{ textAlign: "center", marginTop: "1rem" }}>
          No hay inscripciones
        </p>
      )}
    </div>
  );
};

export default ListadoInscripciones;